import {
  faTruckRegular,
  faHourglassStartRegular,
  faBedFrontRegular,
  faHammerWarRegular,
  faQuestionCircleRegular,
  faTruckSolid,
  faHourglassStartSolid,
  faBedFrontSolid,
  faHammerWarSolid,
  faQuestionCircleSolid,
} from '@/lib/fa'

export const getActivityIcon = (type: number) => {
  let icon = '-'

  switch (type) {
    case 1:
      icon = faHourglassStartRegular
      break
    case 2:
      icon = faHammerWarRegular
      break
    case 3:
      icon = faTruckRegular
      break
    case 0:
      icon = faBedFrontRegular
      break
    case 4:
      icon = faQuestionCircleRegular
      break
  }

  return icon
}

export const getActivityBlackIcon = (type: number) => {
  let icon = '-'

  switch (type) {
    case 1:
      icon = faHourglassStartSolid
      break
    case 2:
      icon = faHammerWarSolid
      break
    case 3:
      icon = faTruckSolid
      break
    case 0:
      icon = faBedFrontSolid
      break
    case 4:
      icon = faQuestionCircleSolid
      break
  }

  return icon
}
